import $ from "jquery";

export function showAllArticles() {
  $('.js-show-all-articles').on('click', function(){
    $(this).parents('.section--related-articles').removeClass('show-3');
    $(this).hide();
  });
}